import React, { Fragment } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { analyticsEvent } from '@/src/analytic_tag_manager';
import { ListMode } from './types';
import SectorCard from './SectorCard';
import { APP_ROUTES } from '@/src/constants';
import EmptyState from './EmptyState';

interface Props {
  items: Array<any>;
  mode?: ListMode;
  selectedItem?: any;
  element: React.ComponentType<any>;
  elementProps?: any;
  specialityName?: string;
  fullAddress?: string;
  useHackyIsEmpty?: boolean; // hacky for check empty result to prevent show empty when the result not loaded
  header?: React.ReactElement;
  mustHideSectorCard?: boolean;
  onItemClick?: React.ReactEventHandler;
  indexItemForSectorCard?: number;
}
const List: React.FC<Props> = ({
  items,
  mode,
  selectedItem,
  element: Component,
  elementProps,
  useHackyIsEmpty,
  header,
  mustHideSectorCard = false,
  onItemClick,
  indexItemForSectorCard = 3,
}) => {
  const router = useRouter();

  const [state, setState] = React.useState('');
  const timeoutId = React.useRef<NodeJS.Timeout | undefined>();

  React.useEffect(() => {
    if (useHackyIsEmpty) {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      if (items.length === 0) {
        timeoutId.current = setTimeout(() => {
          analyticsEvent({
            category: 'Search',
            action: 'NoResultSearch',
          });

          setState('empty');
        }, 1000);
      } else {
        setState('');
      }
      return () => {
        // Clear timeout before unmount
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
      };
    }
    if (items.length === 0) {
      analyticsEvent({
        category: 'Search',
        action: 'NoResultSearch',
      });
    }
    // TODO: improve page /search
  }, [items]);

  if ((useHackyIsEmpty && state === 'empty') || items.length === 0) {
    return <EmptyState />;
  }

  return (
    <>
      {header}
      {items.map((item: any, index: number) => {
        const props = {
          item,
          ref: item.ref,
          className: clsx({
            selected: selectedItem && selectedItem.id === item.id,
          }),
          onClick: onItemClick,
        };
        const renderItem = (
          <Component {...props} {...elementProps} mode={mode} />
        );

        return (
          <Fragment key={item.id}>
            {renderItem}
            {mode === 'tlc' &&
              !mustHideSectorCard &&
              router.pathname.startsWith(APP_ROUTES.TLC.NO_RDV_SEARCH) &&
              index === 2 &&
              items.length > indexItemForSectorCard && <SectorCard />}
          </Fragment>
        );
      })}
    </>
  );
};

export default React.memo(List);
